import { ID_PLACE_DEATH } from 'civil-status/components/step/form/last-step/accordions/section/list/list-place-death';
import { SectionVM, DatiMorte, ParentVM } from 'civil-status/view-models/step-form';
import { ID_ALTRO_STATO } from 'shell/components/shared/foreign-state-list';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { DESCRIPTION_ITALIAN_NATION, ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';

export const transformerDatiMorte = (
  idEvento?: number,
  dataSection?: SectionVM,
  subject?: ParentVM
): DatiMorte | undefined => {
  if (!dataSection) {
    return undefined;
  }

  const isOtherState = dataSection?.foreign?.state?.code === ID_ALTRO_STATO;
  const isOtherMunicipality =
    dataSection?.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    dataMortePresuntaDa:
      dataSection.isDatePresumed && dataSection.datePresumedStart
        ? dataSection.datePresumedStart.toFormat('yyyy-MM-dd')
        : undefined,
    dataMortePresuntaA:
      dataSection.isDatePresumed && dataSection.datePresumedEnd
        ? dataSection.datePresumedEnd.toFormat('yyyy-MM-dd')
        : undefined,
    noteDataPresuntaMorte: dataSection.notePresumed || undefined,
    dataMorte:
      !dataSection.isDatePresumed && dataSection.dateDeath
        ? dataSection.dateDeath.toFormat('yyyy-MM-dd')
        : subject && subject.generality?.dateDeath
        ? subject.generality?.dateDeath.toFormat('yyyy-MM-dd')
        : undefined,
    oraMorte:
      !dataSection.isDatePresumed && dataSection.timeDeath
        ? Number.parseInt(dataSection.timeDeath.toFormat('HH'), 10)
        : undefined,
    minutoMorte:
      !dataSection.isDatePresumed && dataSection.timeDeath
        ? Number.parseInt(dataSection.timeDeath.toFormat('mm'), 10)
        : undefined,
    luogoMorte:
      dataSection.placeDeath === ID_PLACE_DEATH.ALTRO
        ? dataSection.otherPlaceDeath || undefined
        : dataSection.placeDeath || undefined,
    idComuneMorte: dataSection.italian?.municipality?.code?.toString()
      ? dataSection.italian?.municipality.code
      : undefined,
    nomeComuneMorte: isOtherMunicipality
      ? dataSection.italian?.otherMunicipality || undefined
      : dataSection.italian?.municipality?.description,
    nomeStatoMorte: dataSection.italian?.municipality?.description
      ? DESCRIPTION_ITALIAN_NATION
      : isOtherState
      ? dataSection.foreign?.otherState || undefined
      : dataSection.foreign?.state?.value,
    idStatoMorte: dataSection.italian?.municipality?.description
      ? ID_ITALIAN_NATION
      : dataSection?.foreign?.state?.code
      ? Number?.parseInt(dataSection?.foreign?.state?.code, 10)
      : undefined,
    nomeComuneEsteroMorte: dataSection?.foreign?.locationForeign || undefined,
    idProvinciaMorte: dataSection.italian?.municipality?.idProvince || undefined,
    siglaProvincia: dataSection.italian?.municipality?.province || undefined,
    indirizzoMorte: dataSection.address || undefined,
    nrNullaOsta: dataSection.numeroNullaOsta || undefined,
  };
};
